import {call, put, takeLatest, fork, all, delay,} from 'redux-saga/effects';
import * as Types from '../constants/Types';
import * as CategoryService from './../services/categoryService';

import i18n from '../constants/initLng';
import * as Func from "../helpers/functions";
import {PATHS, SAGA_DELAY_TIMEOUT} from '../constants/Define';
import { notification} from 'antd'
import {
    setListCategories as setListCategoriesAction,
    setListAllCategories as setListAllCategoriesAction,
    setCategoryDetail as setCategoriesDetailAction,
} from './../actions/categoryAction';
import history from './../helpers/history';

function* getListCategory() {
    yield takeLatest(Types.CATEGORY_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const pageSize = action.filters.pageSize ? action.filters.pageSize > 10 ? action.filters.pageSize : undefined : undefined;
        const pageIndex = action.filters.pageIndex ? action.filters.pageIndex > 1 ? action.filters.pageIndex : undefined : undefined;
        const params = {
            ...action.filters,
            pageSize, pageIndex,
        };
        yield delay(SAGA_DELAY_TIMEOUT);
        const result = yield call(CategoryService.getCategories, params);
        yield put(setListCategoriesAction(result));
    }, errorHandleCategory(Types.CATEGORY_LIST_FAIL)))
}

function* getListAllCategory() {
    yield takeLatest(Types.CATEGORY_LIST_ALL_ACTION, Func.sagaWrapper(function* (action) {
        yield delay(SAGA_DELAY_TIMEOUT);
        const result = yield call(CategoryService.getAllCategories, {});
        yield put(setListAllCategoriesAction(result));
    }, errorHandleCategory(Types.CATEGORY_LIST_FAIL)))
}

function* getCategoryDetail() {
    yield takeLatest(Types.CATEGORY_DETAIL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(CategoryService.getCategoryDetail, action.id);
        yield put(setCategoriesDetailAction(result));
    }, errorHandleCategory(Types.CATEGORY_DETAIL_FAIL)))
}

function* updateCategoryDetail() {
    yield takeLatest(Types.CATEGORY_DETAIL_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        const result = yield call(CategoryService.updateCategoryDetail, action.category.category);
        Func.sagaSuccessMessage({
            action,
            message: `${i18n.t('notification.updateSuccess')}`,
            description: `${i18n.t('item.category.title')} "${action.category.category.name}"`
        })
        yield put(setCategoriesDetailAction(action.category.category));
    }, errorHandleCategory(Types.CATEGORY_DETAIL_FAIL)))
}

function* createCategoryDetail() {
    yield takeLatest(Types.CATEGORY_DETAIL_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        const result = yield call(CategoryService.createCategoryDetail, action.category);
        Func.sagaSuccessMessage({
            action,
            message: `${i18n.t('notification.createSuccess')}`,
            description: `${i18n.t('item.category.title')} "${action.category.name}"`
        })
        yield put(setCategoriesDetailAction(result));
        history.push(PATHS.CATEGORY.LIST.path);
        history.go();
    }, errorHandleCategory(Types.CATEGORY_DETAIL_FAIL)))
}

function* deleteCategoryDetail() {
    yield takeLatest(Types.CATEGORY_DETAIL_DELETE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        const result = yield call(CategoryService.deleteCategoryDetail, action.category);
        Func.sagaSuccessMessage({
            action,
            message: `${i18n.t('notification.removeSuccess')}`,
        });
        const params = {
            ...action.filters,
            PageIndex: action.filters.pageIndex && action.filters.pageIndex > 1 ? action.filters.pageIndex : undefined,
            PageSize: action.filters.pageSize && action.filters.pageSize > 10 ? action.filters.pageSize : undefined,
        };
        const resultList = yield call(CategoryService.getCategories, params);
        yield put(setListCategoriesAction(resultList));
    }, errorHandleCategory(Types.CATEGORY_DETAIL_FAIL)));
}

// TRANSLATE
function* createCategoryTranslate() {
    yield takeLatest(Types.CATEGORY_CREATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(CategoryService.createCategoryTranslate, action.category);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.201'), action.category.translate.languageName);
        yield put({ type: Types.CATEGORY_CREATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.CATEGORY_DETAIL_ACTION, id: action.category.id });
    }, errorHandleCategory(Types.CATEGORY_FAIL)))
}

function* updateCategoryTranslate() {
    yield takeLatest(Types.CATEGORY_UPDATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(CategoryService.updateCategoryTranslate, action.category);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'), action.category.translate.languageName);
        yield put({ type: Types.CATEGORY_UPDATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.CATEGORY_DETAIL_ACTION, id: action.category.id });
    }, errorHandleCategory(Types.CATEGORY_FAIL)))
}

function* deleteCategoryTranslate() {
    yield takeLatest(Types.CATEGORY_DELETE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(CategoryService.deleteCategoryTranslate, action.category.translate.id);
        Func.sagaSuccessMessage(action, i18n.t('notification.removeSuccess'), action.category.translate.languageName);
        yield put({ type: Types.CATEGORY_DELETE_TRANSLATE_SUCCESS });
        yield put({ type: Types.CATEGORY_DETAIL_ACTION, id: action.category.id });
    }, errorHandleCategory(Types.CATEGORY_FAIL)))
}

function errorHandleCategory(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    }, 'category');
}

export function* categorySaga() {
    yield all([
        fork(getListCategory),
        fork(getCategoryDetail),
        fork(updateCategoryDetail),
        fork(createCategoryDetail),
        fork(deleteCategoryDetail),
        fork(getListAllCategory),
        fork(createCategoryTranslate),
        fork(updateCategoryTranslate),
        fork(deleteCategoryTranslate),
    ])
}
